import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { generateUrl } from 'data/utils';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { GetAllProfessionalsSelectOptionsUseCaseInterface } from 'domain/usecases';

export class RemoteGetAllProfessionalsSelectOptions
  implements GetAllProfessionalsSelectOptionsUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<GetAllProfessionalsSelectOptionsUseCaseInterface.Result>,
  ) {}

  async execute(
    params: GetAllProfessionalsSelectOptionsUseCaseInterface.Params,
  ): Promise<GetAllProfessionalsSelectOptionsUseCaseInterface.Result> {
    const requestUrl = generateUrl(this.url, params);

    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: requestUrl,
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError();
    }
  }
}
